import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Skeleton from "@mui/material/Skeleton";
import Stack, { type StackProps } from "@mui/material/Stack";
import { type FC, type ReactNode } from "react";
import * as Styled from "./InfoList.styled";
import { InfoListItem } from "./InfoListItem";

export const InfoTooltipPlacement = {
    Left: "left",
    Right: "right",
} as const;

export type InfoTooltipPlacement = (typeof InfoTooltipPlacement)[keyof typeof InfoTooltipPlacement];

export type InformationValue = {
    title: string;
    description?: ReactNode;
    tooltipInformationText?: string;
    tooltipInformationTitle?: string;
    tooltipPlacement?: InfoTooltipPlacement;
    additionalElements?: ReactNode[] | ReactNode;
    alertInfoText?: string;
};

type InfoListProps = {
    information: InformationValue[];
    isLoading?: boolean;
    skeletonCount?: number;
    additionalBottomContent?: ReactNode;
    showBottomDivider?: boolean;
};

export const InfoList: FC<InfoListProps & StackProps> = ({
    isLoading,
    information,
    skeletonCount = 3,
    additionalBottomContent,
    showBottomDivider = false,
    ...rest
}) => {
    return (
        <Stack {...rest}>
            <Styled.InfoListPaper>
                <Stack spacing={3} divider={<Divider />}>
                    {!isLoading
                        ? information
                              .filter((i) => !!i)
                              .map((information, i) => (
                                  <InfoListItem
                                      key={i}
                                      infoTitle={information.title}
                                      infoValue={information.description}
                                      infoTooltipText={information.tooltipInformationText}
                                      infoTooltipTitle={information.tooltipInformationTitle}
                                      infoTooltipPlacement={information.tooltipPlacement}
                                      additionalElements={information.additionalElements}
                                      alertInfoText={information.alertInfoText}
                                  />
                              ))
                        : [...Array(skeletonCount)].map((_, i) => (
                              <InfoListItem
                                  key={i}
                                  infoTitle={<Skeleton width="100%" />}
                                  infoValue={<Skeleton width="100%" />}
                              />
                          ))}
                    {showBottomDivider && <Box> </Box>}
                </Stack>
                {additionalBottomContent}
            </Styled.InfoListPaper>
        </Stack>
    );
};
